<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="#ff64ad">
            <span class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>

            <template v-slot:action="{ attrs }">
              <v-btn
                class="body-1 font-weight-bold text-capitalize"
                color="white"
                icon
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <v-row>
            <v-col 
              cols="12" 
              md="7">
              <v-card 
                flat
                outlined>
                <v-card-text>
                  <ValidationObserver ref="form">
                    <v-form class="text-left">
                      <div
                        class="mb-2"
                        style="font-size: 16px;">
                        Silahkan masukkan konten untuk halaman aplikasi SAKURA <b>Tentang Kami</b> dibawah ini:
                      </div>

                      <v-divider class="mb-6" style="border: 3px solid #eaeaea; border-radius: 50px;"/>

                      <div class="mb-6">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Deskripsi
                          <span class="error--text">
                            (wajib diisi)
                          </span>
                        </div>

                        <div
                          class="content_quil">
                          <quill-editor 
                            ref="myTextEditor"
                            :options="{
                              placeholder: 'Contoh. Tanggul sungai dengkeng jebol, kontruksi tidak bagus'
                            }"
                            v-model="form.content">
                          </quill-editor>
                        </div>
                      </div>
                    </v-form>
                  </ValidationObserver>
                  
                  <v-alert 
                    type="error" 
                    text dense prominent 
                    class="mt-6"
                    v-show="message.error.length > 0">
                    {{  message.error }}
                  </v-alert>
                </v-card-text>

                <v-card-text
                  class="pt-0">
                  <v-divider class="mb-4" style="border: 3px solid #eaeaea; border-radius: 50px;"/>

                  <v-card-actions>
                    <v-spacer/>

                    <v-btn
                      color="#ff64ad"
                      elevation="0"
                      class="body-2 font-weight-bold text-capitalize white--text"
                      :disabled="process.form"
                      :loading="process.form"
                      v-on:keyup.enter="save()"
                      @click="save()">
                      <v-icon small class="mr-1">mdi-check-bold</v-icon>
                      Simpan
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col 
              cols="12" 
              md="5"
              class="d-flex justify-center">
              <v-card
                flat
                width="350"
                height="75vh"
                style="border: 5px solid #e0e0e0; border-radius: 30px;">
                <v-card-title 
                  class="cursor-pointer pa-4"
                  style="border-radius: 25px 25px 15px 15px;
                        position: absolute;
                        width: 100%;
                        z-index: 10;
                        background: #ff64ad;">
                  <v-icon 
                    color="white">
                    mdi-arrow-left-thick
                  </v-icon>

                  <span
                    class="body-1 font-weight-bold text-capitalize white--text ml-1">
                    Tentang Kami
                  </span>
                </v-card-title>

                <v-card-text 
                  class="pa-0 pt-6">
                  <v-carousel 
                    v-model="selected.banner" 
                    cycle
                    hide-delimiters 
                    :show-arrows="false" 
                    height="auto">
                    <v-carousel-item
                      v-for="(item, index) in process.banner ? 3 : list"
                      :key="index">
                      <v-skeleton-loader
                        class="ma-auto"
                        :loading="process.banner"
                        type="image">
                        <div>
                          <v-img v-if="!process.banner && list.length > 0"
                            width="100%"
                            height="250"
                            alt="kominfo" 
                            :src="item.image"
                            gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .1)"
                            class="ma-auto d-flex align-end">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </v-skeleton-loader>
                    </v-carousel-item>
                  </v-carousel>
                </v-card-text>

                <v-card-text
                  class="text-center"
                  style="position: relative; 
                      top: -80px;">
                  <v-btn 
                    v-for="(item, index) in list" 
                    :key="index"
                    :width="selected.banner === index ? 5 : 8"
                    :height="selected.banner === index ? 10 : 8"
                    elevation="0"
                    x-small
                    :rounded="selected.banner === index"
                    :fab="selected.banner !== index"
                    :color="selected.banner === index ? '#ff64ad' : '#fff'"
                    class="ma-1"
                    @click="selected.banner = index">
                  </v-btn>
                </v-card-text>

                <v-card-text
                  style="border-radius: 15px 15px 25px 25px; 
                      position: relative; 
                      top: -80px;
                      background: #FFF;
                      height: 48.5vh;">
                  <div class="mb-3">
                    <div class="title black--text">
                      Tentang Kami
                    </div>

                    <div class="body-2 font-weight-light black--text" style="opacity: 60%;">
                      Mengenai Aplikasi SAKURA
                    </div>
                  </div>

                  <div class="body-2 font-weight-light line-text-second black--text"
                    style="overflow-y: auto; 
                          height: calc((100vh - 500px) - 100px); 
                          opacity: 60%;">
                    <div 
                      class="paragraph mb-3"
                      style="text-indent: 25px; text-align: justify;">
                      <v-skeleton-loader
                        v-for="(item, index) in process.load ? 4 : 1"
                        :key="index"
                        class="ma-auto"
                        :loading="process.load"
                        type="list-item-three-line">
                        <div>
                          <span v-if="!process.load"
                            v-html="form.content">
                          </span>
                        </div>
                      </v-skeleton-loader>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },
        selected: {
          banner: 0
        },
        list: [],
        pagination: {},
        form: {
          id: '',
          title: '',
          content: '',
          status: 'publish',
          type: 'aboutus'
        },
        process: {
          banner: false,
          load: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchBanner()
        this.fetchData()
      },
      async fetchBanner () {
        this.process.banner = true

        let params = {
          type: 'banner'
        }

        await get('site', { params })
        .then(response => {
          let res = response.data

          this.process.banner = false
            
          if (res.code === 200) {
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      async fetchData () {
        this.process.load = true

        let params = {
          type: 'aboutus'
        }

        await get('site', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.form = res.data[0]
          }
        })
      },
      async save() {
        this.message.error = ''
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`site/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetchData()
            } else {
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style>
  .content_quil .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0px 0px;
  }
  .content_quil .ql-container.ql-snow {
    border-radius: 0px 0px 4px 4px;
    height: 480px;
  }
  .content_quil .quill-editor .ql-editor {
    min-height: 480px;
  }
</style>